/**
 * Timezone Info Component
 * @description Compact timezone information card for venues page
 * Shows current venue timezone and browser timezone for reference
 */

import React from 'react';
import { Typography } from '@mui/material';
import { useVenueTimeFormatters } from '../../../utils/Hooks/venue/useVenueTimeFormatters';
import {
    TimezoneContainer,
    TimezoneContent,
    TimezoneRow,
    TimezoneLabel,
    VenueChip,
    BrowserChip,
    TimezoneNote,
    VenueIcon,
    BrowserIcon,
} from './TimezoneInfo.styles';

const TimezoneInfo = () => {
    const { venueTimezone } = useVenueTimeFormatters();
    const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    return (
        <TimezoneContainer>
            <Typography variant="h6">Timezone Info</Typography>
            <Typography variant="subtitle2">
                <em>Current timezone settings for this venue.</em>
            </Typography>

            <TimezoneContent>
                <TimezoneRow>
                    <VenueIcon />
                    <TimezoneLabel variant="body2">
                        <strong>Venue:</strong>
                    </TimezoneLabel>
                    <VenueChip
                        label={venueTimezone}
                        size="small"
                        color="primary"
                        variant="filled"
                    />
                </TimezoneRow>

                <TimezoneRow>
                    <BrowserIcon />
                    <TimezoneLabel variant="body2">
                        <strong>Browser:</strong>
                    </TimezoneLabel>
                    <BrowserChip
                        label={browserTimezone}
                        size="small"
                        variant="filled"
                    />
                </TimezoneRow>
            </TimezoneContent>

            <TimezoneNote variant="caption">
                All times display in venue timezone
            </TimezoneNote>
        </TimezoneContainer>
    );
};

export default TimezoneInfo;
